import { Box, Checkbox, Flex, Heading, Message, Text } from 'ui'
import { Map } from 'components/Map'
import { Controller, useFormContext } from 'react-hook-form'
import { DetailsForm } from '../../schemas'

const ORDER_LOCATION_RADIUS_MILES = 50
const METERS_PER_MILE = 1609.344
const ORDER_LOCATION_RADIUS_METERS =
  ORDER_LOCATION_RADIUS_MILES * METERS_PER_MILE

interface ConfirmOrderLocationsProps {
  coordinates: {
    lat: number
    lng: number
  }
  locationName?: string
}

export const ConfirmOrderLocations = (props: ConfirmOrderLocationsProps) => {
  const { coordinates, locationName } = props
  const {
    control,
    formState: { errors },
  } = useFormContext<DetailsForm>()

  return (
    <Flex flexDirection="column" mt={4}>
      <Controller
        name={'confirmOrderLocations'}
        control={control}
        render={({ field }) => (
          <>
            <Heading level={3} my={1}>
              Confirm Order Locations
            </Heading>

            <Text fontSize={1} color="lightText" mt={2}>
              Delivery requests must only contain orders that are within 50
              miles of the pickup location (inside the red circle).
            </Text>
            <Checkbox {...field} value={field.value ?? false}>
              <Text mt={2}>
                I understand that delivery requests must only contain orders
                that are within 50 miles of the pickup location
              </Text>
            </Checkbox>
            {errors.confirmOrderLocations?.message ? (
              <Message variant={'error'} mt={3}>
                {errors.confirmOrderLocations.message.toString()}
              </Message>
            ) : null}
            <Box mt={3}>
              <Map
                center={coordinates}
                zoom={8}
                markers={[
                  {
                    position: coordinates,
                    title: locationName ?? 'Selected Location',
                  },
                ]}
                circle={{
                  lat: coordinates.lat,
                  lng: coordinates.lng,
                  radius: ORDER_LOCATION_RADIUS_METERS,
                  draggable: false,
                }}
                mapOptions={{
                  fullscreenControl: false,
                  mapTypeControl: false,
                  streetViewControl: false,
                }}
              />
            </Box>
          </>
        )}
      />
    </Flex>
  )
}
